import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "./Login";
import {Button, Card, Input, Popconfirm, Table, Tag} from "antd";
import Colors from "../../styles/Colors";
import {BiPencil, BiPlus, BiRefresh, BiTrash} from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import PlantillaModal from "../PlantillaModal";
import PlantillaLista from "../PlantillaLista";
import UsuarisDeescolaList from '../menudesign/components/UsuarisDeEscolaList';
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import {Dayjs} from 'dayjs';
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {GetEscoles} from "../../dao/root/GetEscoles";
import {Escola} from "../../model/root/Escola";
import { DeleteEscola } from '../../dao/root/DeleteEscola';
import EscolesModal from './component/EscolesModal';
import { Menu } from '../../model/root/Menu';

const Escoles = () => {
    const titol: string = "ESCOLES";
    const nomPermis: string = "GestioEscoles";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<Escola[]>([]);
    const [elementSelected, setElementSelected] = useState<Escola>(new Escola());
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());

    const [menus, setMenus] = useState<{ label: string; value: string; }[]>([{
        label: "",
        value: ""
    }]);

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetEscoles(page);
        setDades(dades);
        await setNameFilters(dades);
        await handleLoadingChange(false);
    }

    function toggleTable() {
        setVisible(!visible);
    }

    async function deleteElement(id: number) {
        setLoading(true);
        await DeleteEscola(id, page, userId);
        await checkDades();
    }

    function afegirElement(element: Escola) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function togleNouElement(element: Escola, edit: boolean) {
        setNouElement(!nouElement);
        setEditar(edit);
        setElementSelected(element);
    }

    function handleCloseModal() {
        setNouElement(false);
        checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    function setNameFilters(elements: Escola[]) {
        const ingredientNames = elements.map((element) => ({
            text: element.nom,
            value: element.nom,
        }));
        setNomFiltres(ingredientNames);
    }

    function setMenusOptions(menus: Menu[]) {
        if (menus && menus?.length) {
            const options = menus.map(contact => ({
                label: `${contact.label}`,
                value: contact.key + ""
            }));
            setMenus(options);
        }
    }

    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/

    const columns: ColumnsType<Escola> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
            render: (estat, ele) => (ele.nom + " (" + ele.id_loop + ")")
        },
        {
            key: 'nom',
            title: 'Comentaris',
            dataIndex: 'comentaris',
            width: 30
        },
        {
            key: 'tipus',
            title: 'Tipus',
            dataIndex: 'tipus',
            width: 30,
            filterSearch: true,
            filters: nomFiltres,
            onFilter: (value, record) => (typeof value === 'string' ? record.nom.startsWith(value) : false),
            render: (estat, ele) => (
                <>
                    {ele.casals ? <Tag color={Colors.colors.color4}>CASAL</Tag> : ""}
                    {ele.menjador ? <Tag color={Colors.colors.color5}>MENJADOR</Tag> : ""}
                    {ele.extraescolars ? <Tag color={Colors.colors.color2}>EXTRAESCOLAR</Tag> : ""}
                    {ele.proposta ? <Tag color={Colors.colors.color1}>PROPOSTA</Tag> : ""}
                    {ele.referent !== null ? <Tag color={Colors.colors.color3}>REFERENT: {ele.referent}</Tag> : ""}
                </>
            )
        },
        {
            key: 'menu',
            title: 'Menus',
            dataIndex: 'menu',
            width: 30,
            render: (estat, ele) => (
                <Tag color={Colors.colors.color2}>{ele.menu}</Tag>
            )
        },
        {
            key: 'accions', title: 'Accions', dataIndex: 'accions', width: 30,
            render: (estat, ele) => (
                <>
                    <Button title={"Editar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={() => togleNouElement(ele, true)}><BiPencil/></Button>
                    {" "}
                    <Popconfirm
                        title="Eliminant"
                        description="Vols eliminar definitivament aquest element?"
                        onConfirm={() => deleteElement(ele.id)}
                        icon={<QuestionCircleOutlined style={{color: 'red'}}/>}
                    >
                        <Button title={"Eliminar"}
                                style={{backgroundColor: Colors.colors.color5}}><BiTrash/></Button>
                    </Popconfirm>
                    {" "}
                    <Button title={"Mostrar"} onClick={() => togleNouElement(ele, false)}
                            style={{backgroundColor: Colors.colors.color4}}><BsEye/></Button>
                </>
            ),
        },
    ];

    const tableProps: TableProps<Escola> = {
        loading
    };

    const onChange: TableProps<Escola>['onChange'] =
        (pagination,
         filters,
         sorter,
         extra) => {
            console.log('params', pagination, filters, sorter, extra);
        };

    const expandedRowRender2 = (ele: Escola) => {
        return (
            <UsuarisDeescolaList element={ele} page={page}/>
        );
    };

    async function handleDownload(id: string) {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <div className={"actionButtons"}>
                            <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                afegirElement(new Escola())}><BiPlus/></Button>
                            <Button title={"Refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                checkDades()}><BiRefresh/></Button>
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                        {visible && (
                            <Table
                                {...tableProps}
                                onChange={onChange}
                                columns={columns}
                                dataSource={coleccio}
                                expandable={{
                                    expandedRowRender: (record) =>
                                        expandedRowRender2(record),
                                    rowExpandable: (record) => true,

                                }}
                            />
                        )}
                    </Card>
                    <br/>
                    <Historials pantalla={"PLANTILLA"} pagina={page}/>
                    {nouElement && (
                        <EscolesModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}
                                        menus={menus} page={page}/>
                    )}
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Escoles;
